/*! Cazotti bundle builder */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function findVariant(product, color, size) {
    var colorKey = (product.colorOption || 'Color').toLowerCase();
    var sizeKey = (product.sizeOption || 'Size').toLowerCase();
    return (product.variants || []).find(function (v) {
      var c = '', s = '';
      (v.options || []).forEach(function (o) {
        var n = String(o.name || '').toLowerCase();
        if (n === colorKey || n.indexOf('color') >= 0 || n.indexOf('colour') >= 0) c = o.value;
        if (n === sizeKey || n.indexOf('size') >= 0) s = o.value;
      });
      // fallback option1/option2 shape
      if (!c && v.option1) c = v.option1;
      if (!s && v.option2) s = v.option2;
      return c === color && s === size;
    });
  }

  function openCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      try { drawer.show(); return; } catch (e) {}
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var btn = document.querySelector('[aria-controls="cart-drawer"], button[aria-controls="cart-drawer"]');
    if (btn) btn.click();
  }

  async function refreshCartUi() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    try {
      var sections = ['cart-drawer', 'cart-icon-bubble'];
      var res = await fetch('/?sections=' + sections.join(','));
      if (res.ok) {
        var json = await res.json();
        Object.keys(json).forEach(function (id) {
          var el = document.getElementById('shopify-section-' + id) || document.querySelector('#cart-drawer') || document.querySelector('cart-drawer');
          if (id === 'cart-drawer' && el && json[id]) {
            var tmp = document.createElement('div');
            tmp.innerHTML = json[id];
            var next = tmp.querySelector('cart-drawer') || tmp.firstElementChild;
            var cur = document.querySelector('cart-drawer');
            if (cur && next) cur.innerHTML = next.innerHTML;
          }
        });
      }
    } catch (e) {}
    openCart();
  }

  ready(function () {
    var root = document.querySelector('[data-cazotti-bundle-root]');
    if (!root) return;
    var dataEl = document.getElementById('cazotti-bundle-product-json');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var state = {
      qty: 0,
      pieces: []
    };

    var tiersEl = root.querySelector('[data-tiers]');
    var piecesEl = root.querySelector('[data-pieces]');
    var summaryEl = root.querySelector('[data-summary]');
    var addBtn = root.querySelector('[data-add-bundle]');
    var clearBtn = root.querySelector('[data-clear-bundle]');
    var noteEl = root.querySelector('[data-note]');

    var colors = product.colors || [];
    var sizes = product.sizes || [];
    var defaultColor = product.selectedColor || colors[0];
    var defaultSize = product.selectedSize || sizes.find(function (s) { return s !== 'S'; }) || sizes[0];

    function setTier(qty) {
      if (state.qty === qty) {
        // toggle off
        state.qty = 0;
        state.pieces = [];
      } else {
        var prev = state.pieces.slice();
        state.qty = qty;
        state.pieces = [];
        for (var i = 0; i < qty; i++) {
          state.pieces.push({
            color: (prev[i] && prev[i].color) || defaultColor,
            size: (prev[i] && prev[i].size) || defaultSize
          });
        }
      }
      render();
    }

    function renderTiers() {
      tiersEl.querySelectorAll('[data-qty]').forEach(function (btn) {
        var q = parseInt(btn.getAttribute('data-qty'), 10);
        btn.classList.toggle('is-active', state.qty === q);
        btn.setAttribute('aria-pressed', state.qty === q ? 'true' : 'false');
      });
    }

    function pieceHtml(piece, index) {
      var colorOpts = colors.map(function (c) {
        return '<option value="' + c.replace(/"/g, '&quot;') + '"' + (c === piece.color ? ' selected' : '') + '>' + c + '</option>';
      }).join('');
      var sizeOpts = sizes.map(function (s) {
        return '<option value="' + s.replace(/"/g, '&quot;') + '"' + (s === piece.size ? ' selected' : '') + '>' + s + '</option>';
      }).join('');
      var v = findVariant(product, piece.color, piece.size);
      var avail = v ? (v.available !== false) : false;
      return (
        '<div class="cazotti-bundle__piece" data-piece="' + index + '">' +
          '<div class="cazotti-bundle__piece-head"><strong>Piece ' + (index + 1) + '</strong>' +
          (avail ? '<span class="ok">In stock</span>' : '<span class="bad">Unavailable</span>') +
          '</div>' +
          '<div class="cazotti-bundle__piece-fields">' +
            '<label>Color<select data-field="color">' + colorOpts + '</select></label>' +
            '<label>Size<select data-field="size">' + sizeOpts + '</select></label>' +
          '</div>' +
        '</div>'
      );
    }

    function calc() {
      var ok = true;
      var total = 0;
      var ids = [];
      state.pieces.forEach(function (p) {
        var v = findVariant(product, p.color, p.size);
        if (!v || v.available === false) ok = false;
        else {
          total += Number(v.price || product.price || 0);
          ids.push(v.id);
        }
      });
      var pct = state.qty >= 4 ? 20 : state.qty >= 3 ? 15 : state.qty >= 2 ? 10 : 0;
      var discount = Math.round(total * (pct / 100));
      return { ok: ok && state.qty >= 2, total: total, discount: discount, final: total - discount, pct: pct, ids: ids };
    }

    function renderSummary() {
      if (!state.qty) {
        summaryEl.hidden = true;
        addBtn.disabled = true;
        clearBtn.hidden = true;
        noteEl.textContent = 'Choose Buy 2, 3 or 4 — then pick color and size for each piece.';
        return;
      }
      var c = calc();
      summaryEl.hidden = false;
      clearBtn.hidden = false;
      summaryEl.innerHTML =
        '<div><span>Subtotal</span><strong>' + money(c.total) + '</strong></div>' +
        (c.pct ? '<div><span>Bundle save (' + c.pct + '%)</span><strong>-' + money(c.discount) + '</strong></div>' : '') +
        '<div class="cazotti-bundle__final"><span>You pay</span><strong>' + money(c.final) + '</strong></div>';
      addBtn.disabled = !c.ok;
      addBtn.textContent = c.ok ? ('Add ' + state.qty + ' pieces to cart') : 'Select available sizes/colors';
      noteEl.textContent = 'Discount code applies automatically in cart (BUNDLE' + (state.qty >= 4 ? '4' : state.qty) + ').';
    }

    function render() {
      renderTiers();
      if (!state.qty) {
        piecesEl.innerHTML = '';
        piecesEl.hidden = true;
      } else {
        piecesEl.hidden = false;
        piecesEl.innerHTML = state.pieces.map(pieceHtml).join('');
      }
      renderSummary();
    }

    tiersEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      e.preventDefault();
      setTier(parseInt(btn.getAttribute('data-qty'), 10));
    });

    piecesEl.addEventListener('change', function (e) {
      var sel = e.target.closest('select[data-field]');
      if (!sel) return;
      var pieceEl = sel.closest('[data-piece]');
      var idx = parseInt(pieceEl.getAttribute('data-piece'), 10);
      var field = sel.getAttribute('data-field');
      state.pieces[idx][field] = sel.value;
      render();
    });

    clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      state.qty = 0;
      state.pieces = [];
      render();
    });

    addBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      var c = calc();
      if (!c.ok) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      try {
        // clear qty on main form so single add doesn't confuse
        var items = c.ids.map(function (id) {
          return { id: id, quantity: 1 };
        });
        var res = await fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) {
          var err = await res.json().catch(function () { return {}; });
          throw new Error(err.description || err.message || 'Could not add bundle');
        }
        // apply best discount code
        var code = state.qty >= 4 ? 'BUNDLE4' : state.qty >= 3 ? 'BUNDLE3' : 'BUNDLE2';
        await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' });
        await refreshCartUi();
        addBtn.textContent = 'Added ✓';
        setTimeout(function () { renderSummary(); }, 1200);
      } catch (err) {
        addBtn.textContent = 'Error — try again';
        console.warn('[cazotti-bundle]', err);
        setTimeout(function () { renderSummary(); }, 1500);
      }
    });

    render();
  });
})();
